import { TypeEnum } from "../../components/shared/widgets/Form/enums/TypeEnum";
import { AgentCategoryEnum } from "../../enums/AgentCategory.enum";
import { ITeam } from "../../models/Team.model";

export const FakeTeams: ITeam[] = [
  // {
  //   id: "1",
  //   logo: "/assets/images/randon-logo.png",
  //   name: "Product Test Automation Team",
  //   description:
  //     "An end-to-end workflow for automated test case analysis, data preparation, BDD test generation and scoring, MongoDB storage, and Squish testing.",
  //   agents: [
  //     {
  //       id: "1",
  //       name: "Test Case Analyser Agent",
  //       description:
  //         "A comprehensive agent that extracts, parses, writes, and generates summaries for test cases from Excel files.",
  //       agentFormData: {
  //         agentName: "Test Case Analyser Agent",
  //         agentDescription:
  //           "This agent handles the complete workflow for analyzing test cases, including extracting content from Excel, parsing the text, writing outputs to TXT and README files, and generating a summary.",
  //         prompt: "None",
  //         tools: [
  //           "Excel Tool",
  //           "Parsing Tool",
  //           "File Writing Tool - Test Case",
  //           "File Writing Tool - Test Case Analysis",
  //         ],
  //         model: {
  //           label: "GPT 4",
  //           field: "gpt4",
  //         },
  //         flow: {
  //           nodes: [
  //             {
  //               id: "0",
  //               type: "AgentNode",
  //               position: {
  //                 x: 300,
  //                 y: 150,
  //               },
  //               data: {
  //                 id: "0",
  //                 title: "Extract Text from Excel",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "excel_path",
  //                       type: TypeEnum.Input,
  //                       description: "Path to the Excel file.",
  //                       value: "RTPS-62790_FED_ISO_Inbound_pacs.008_testcases.xlsx",
  //                       defualtValue: "RTPS-62790_FED_ISO_Inbound_pacs.008_testcases.xlsx",
  //                     },
  //                   ],
  //                   output: {
  //                     type: TypeEnum.Input,
  //                     description: "Extracted sheet data",
  //                     value:"$sheet_data",
  //                   },
  //                 },
  //               },
  //               className: "",
  //             },
  //             {
  //               id: "1",
  //               type: "AgentNode",
  //               position: {
  //                 x: 600,
  //                 y: 150,
  //               },
  //               data: {
  //                 id: "1",
  //                 title: "Parse Excel Text",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "sheet_data",
  //                       type: TypeEnum.Input,
  //                       value:"$sheet_data",
  //                       description: "Extracted data from the Excel file.",
  //                     },
  //                   ],
  //                   output: {
  //                     type: TypeEnum.Input,
  //                     value:"$structured_test_cases",
  //                     description: "Structured test cases",
  //                   },
  //                 },
  //               },
  //               className: "",
  //             },
  //             {
  //               id: "2",
  //               type: "AgentNode",
  //               position: {
  //                 x: 600,
  //                 y: 150,
  //               },
  //               data: {
  //                 id: "2",
  //                 title: "Write Test Cases to TXT",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "structured_test_cases",
  //                       value:"$structured_test_cases",
  //                       type: TypeEnum.Input,
  //                       description: "Parsed test cases to write",
  //                     },
  //                     {
  //                       key: "txt_output_path",
  //                       value:"$testcaseId.txt",
  //                       type: TypeEnum.Input,
  //                       description: "Output path for TXT file.",
  //                     },
  //                   ],
  //                   output: {
  //                     type: TypeEnum.Switch,
  //                     value:"$txt_output_path",
  //                     description: "Confirmation of file creation",
  //                   },
  //                 },
  //               },
  //               className: "",
  //             },
  //             {
  //               id: "3",
  //               type: "AgentNode",
  //               position: {
  //                 x: 1200,
  //                 y: 150,
  //               },
  //               data: {
  //                 id: "3",
  //                 title: "Generate README Summary",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "structured_test_cases",
  //                       value:"$structured_test_cases",
  //                       type: TypeEnum.Input,
  //                       description: "Parsed test cases for summary",
  //                     },
  //                     {
  //                       key: "readme_output_path",
  //                       value:"$testcaseId_README.md",
  //                       type: TypeEnum.Input,
  //                       description: "Output path for README file.",
  //                     },
  //                   ],
  //                   output: {
  //                     type: TypeEnum.Input,
  //                     value:"$readme_output_path",
  //                     description: "Result of README generation",
  //                   },
  //                 },
  //               },
  //               className: "",
  //             },
  //           ],
  //           edges: [
  //             {
  //               id: "e0-1",
  //               source: "0",
  //               target: "1",
  //               type: "smoothstep",
  //             },
  //             {
  //               id: "e1-2",
  //               source: "1",
  //               target: "2",
  //               type: "smoothstep",
  //             },
  //             {
  //               id: "e2-3",
  //               source: "2",
  //               target: "3",
  //               type: "smoothstep",
  //             },
  //           ],
  //         },
  //         welcomeText:
  //           "Welcome to the Test Case Analyser Agent. This agent will guide you through extracting, parsing, writing, and summarizing test cases from Excel files.",
  //       },
  //       category: AgentCategoryEnum.Analyser,
  //       logo: "/assets/images/randon-logo.png",
  //     },
  //     {
  //       id: "2",
  //       name: "Test Data Preparation Agent",
  //       description:
  //         "An agent for preparing test data files, including generating Excel sheets for test cases and creating load files from summaries.",
  //       agentFormData: {
  //         agentName: "Test Data Preparation Agent",
  //         agentDescription:
  //           "This agent handles test data preparation by generating structured Excel sheets and load files, enabling smooth integration with downstream testing processes.",
  //         prompt: "None",
  //         tools: [
  //           "File Writing Tool - Excel Sheet Generator",
  //           "Load File Generator Tool",
  //         ],
  //         model: {
  //           label: "GPT 4",
  //           field: "gpt4",
  //         },
  //         flow: {
  //           nodes: [
  //             {
  //               id: "0",
  //               type: "AgentNode",
  //               position: {
  //                 x: 300,
  //                 y: 150,
  //               },
  //               data: {
  //                 id: "0",
  //                 title: "Generate Excel Sheet for Test Cases",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "test_cases_path",
  //                       type: TypeEnum.Input,
  //                       value: "RTPS-62790_FED_ISO_Inbound_pacs.008_testcases.xlsx",
  //                       description:
  //                         "Path to the original Excel file with test cases.",
  //                     },
  //                     {
  //                       key: "excel_input_path",
  //                       value:"fed.xlsx",
  //                       type: TypeEnum.Input,
  //                       description: "Path to an additional input Excel file.",
  //                     },
  //                     {
  //                       key: "excel_output_path",
  //                       value:"fed.xlsx",
  //                       type: TypeEnum.Input,
  //                       description: "Directory for the output Excel file.",
  //                     },
  //                     {
  //                       key: "test_cases_sheet_name",
  //                       value:"$test_cases_sheet_name",
  //                       type: TypeEnum.Input,
  //                       description: "Sheet name for the test cases.",
  //                     },
  //                     {
  //                       key: "test_scenarios_json_path",
  //                       value:"$test_scenarios.json",
  //                       type: TypeEnum.Input,
  //                       description: "Path to JSON file with test scenarios.",
  //                     },
  //                   ],
  //                   output: {
  //                     type: TypeEnum.Input,
  //                     value:"$excel_output_path",
  //                     description: "Path to the generated Excel file",
  //                   },
  //                 },
  //               },
  //               className: "",
  //             },
  //             {
  //               id: "1",
  //               type: "AgentNode",
  //               position: {
  //                 x: 600,
  //                 y: 150,
  //               },
  //               data: {
  //                 id: "1",
  //                 title: "Generate Load File",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "readme_output_path",
  //                       value:"$readme_output_path",
  //                       type: TypeEnum.Input,
  //                       description: "Path to the README summary file.",
  //                     },
  //                     {
  //                       key: "load_file_output_directory",
  //                       value:"$load_files",
  //                       type: "directory",
  //                       description:
  //                         "Directory for saving generated load files.",
  //                     },
  //                     {
  //                       key: "generate_load_file_flag",
  //                       value:"false",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Flag indicating whether to generate load files.",
  //                     },
  //                   ],
  //                   output: {
  //                     type: "array",
  //                     value:"$load_files",
  //                     description:
  //                       "Paths to the generated load files or confirmation message",
  //                   },
  //                 },
  //               },
  //               className: "",
  //             },
  //           ],
  //           edges: [
  //             {
  //               id: "e0-1",
  //               source: "0",
  //               target: "1",
  //               type: "smoothstep",
  //             },
  //           ],
  //         },
  //         welcomeText:
  //           "Welcome to the Test Data Preparation Agent. This agent generates Excel sheets and load files, supporting test case preparation and data organization.",
  //       },
  //       category: AgentCategoryEnum.Generation,
  //       logo: "/assets/images/randon-logo.png",
  //     },
  //     {
  //       id: "3",
  //       name: "BDD Test Generation Agent",
  //       description:
  //         "An agent for generating BDD (Behavior-Driven Development) test files using structured test cases and predefined patterns.",
  //       agentFormData: {
  //         agentName: "BDD Test Generation Agent",
  //         agentDescription:
  //           "This agent generates feature files in BDD format from structured test cases, utilizing patterns for consistent and standardized test scenarios.",
  //         prompt: "None",
  //         tools: ["Feature Generation Tool"],
  //         model: {
  //           label: "GPT 4",
  //           field: "gpt4",
  //         },
  //         flow: {
  //           nodes: [
  //             {
  //               id: "0",
  //               type: "AgentNode",
  //               position: {
  //                 x: 300,
  //                 y: 150,
  //               },
  //               data: {
  //                 id: "0",
  //                 title: "Generate Feature File",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "structured_test_cases",
  //                       value: "$structured_test_cases",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Structured test cases to be used for feature file generation.",
  //                     },
  //                     {
  //                       key: "pattern",
  //                       value:"Common_Patterns_v1.4.md",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Path to the pattern file for BDD feature file creation.",
  //                     },
  //                     {
  //                       key: "json_directory",
  //                       value:"$json_files",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Directory for storing any generated JSON files.",
  //                     },
  //                     {
  //                       key: "feature_file_output_path",
  //                       value:"$feature_file.feature",
  //                       type: TypeEnum.Input,
  //                       description: "Path to save the generated feature file.",
  //                     },
  //                   ],
  //                   output: {
  //                     value:"$feature_file_output_path",
  //                     type: TypeEnum.Input,
  //                     description:
  //                       "Path to the generated BDD feature file or confirmation message.",
  //                   },
  //                 },
  //               },
  //               className: "",
  //             },
  //           ],
  //           edges: [],
  //         },
  //         welcomeText:
  //           "Welcome to the BDD Test Generation Agent. This agent will generate BDD feature files based on structured test cases and patterns.",
  //       },
  //       category: AgentCategoryEnum.Generation,
  //       logo: "/assets/images/randon-logo.png",
  //     },
  //     {
  //       id: "4",
  //       name: "BDD Test Scoring Agent",
  //       description:
  //         "An agent for evaluating and scoring BDD (Behavior-Driven Development) feature files based on defined quality criteria and patterns.",
  //       agentFormData: {
  //         agentName: "BDD Test Scoring Agent",
  //         agentDescription:
  //           "This agent assesses the quality of BDD feature files by comparing them to established patterns, generating a quality score to ensure test scenarios meet specified standards.",
  //         prompt: "None",
  //         tools: ["Feature Evaluation Tool"],
  //         model: {
  //           label: "GPT 4",
  //           field: "gpt4",
  //         },
  //         flow: {
  //           nodes: [
  //             {
  //               id: "0",
  //               type: "AgentNode",
  //               position: {
  //                 x: 300,
  //                 y: 150,
  //               },
  //               data: {
  //                 id: "0",
  //                 title: "Evaluate Feature File",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "structured_test_cases",
  //                       value:"$structured_test_cases",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Structured test cases used for evaluating the feature file.",
  //                     },
  //                     {
  //                       key: "feature_file_result",
  //                       value:"$feature_file.feature",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Path to the generated BDD feature file to be evaluated.",
  //                     },
  //                     {
  //                       key: "pattern",
  //                       value:"Common_Patterns_v1.4.md",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Path to the pattern file used as a reference for evaluation.",
  //                     },
  //                     {
  //                       key: "evaluation_output_path",
  //                       value:"$evaluation_output.txt",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Path to save the evaluation results or quality score.",
  //                     },
  //                   ],
  //                   output: {
  //                     type: "number",
  //                     value:"$evaluation_output.txt",
  //                     description:
  //                       "Quality score or evaluation result for the BDD feature file.",
  //                   },
  //                 },
  //               },
  //               className: "",
  //             },
  //           ],
  //           edges: [],
  //         },
  //         welcomeText:
  //           "Welcome to the BDD Test Scoring Agent. This agent evaluates the quality of BDD feature files, assigning a score based on predefined patterns and standards.",
  //       },
  //       category: AgentCategoryEnum.Validation,
  //       logo: "/assets/images/randon-logo.png",
  //     },
  //     {
  //       id: "5",
  //       name: "Database Agent",
  //       description:
  //         "An agent for inserting and updating structured test case data in MongoDB, facilitating organized storage and easy retrieval of test data.",
  //       agentFormData: {
  //         agentName: "Database Agent",
  //         agentDescription:
  //           "This agent handles the insertion of test case data into a MongoDB collection, ensuring that test cases are stored in a structured and queryable format for future analysis.",
  //         prompt: "None",
  //         tools: ["MongoDB Tool"],
  //         model: {
  //           label: "GPT 4",
  //           field: "gpt4",
  //         },
  //         flow: {
  //           nodes: [
  //             {
  //               id: "0",
  //               type: "AgentNode",
  //               position: {
  //                 x: 300,
  //                 y: 150,
  //               },
  //               data: {
  //                 id: "0",
  //                 title: "Update to MongoDB",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "readme_file_path",
  //                       type: TypeEnum.Input,
  //                       value:"$readme_output_path",
  //                       description:
  //                         "Path to the README file containing test case summaries.",
  //                     },
  //                     {
  //                       key: "db_name",
  //                       value:"product",
  //                       type: TypeEnum.Input,
  //                       description: "Name of the MongoDB database.",
  //                     },
  //                     {
  //                       key: "collection_name",
  //                       value:"test_cases",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Name of the MongoDB collection for storing test cases.",
  //                     },
  //                     {
  //                       key: "connection_string",
  //                       type: TypeEnum.Input,
  //                       value:"$connection_string",
  //                       description: "Connection string for MongoDB instance.",
  //                     },
  //                     {
  //                       key: "base_path",
  //                       type: TypeEnum.Input,
  //                       value:"$sharepoint_url",
  //                       description:
  //                         "Base URL for linked resources associated with the test cases.",
  //                     },
  //                   ],
  //                   output: {
  //                     type: TypeEnum.Switch,
  //                     value:"true",
  //                     description:
  //                       "Confirmation of successful MongoDB insertion.",
  //                   },
  //                 },
  //               },
  //               className: "",
  //             },
  //           ],
  //           edges: [],
  //         },
  //         welcomeText:
  //           "Welcome to the MongoDB Agent. This agent will insert structured test case data into MongoDB for organized storage and retrieval.",
  //       },
  //       category: AgentCategoryEnum.Database,
  //       logo: "/assets/images/randon-logo.png",
  //     },
  //     {
  //       id: "6",
  //       name: "Test Squish Bundle Agent",
  //       description:
  //         "An agent for preparing test cases and related files for execution with the Squish testing framework.",
  //       agentFormData: {
  //         agentName: "Test Squish Bundle Agent",
  //         agentDescription:
  //           "This agent organizes and prepares test case files and scripts for execution in the Squish automated testing framework, ensuring that all necessary files are in place for a smooth test run.",
  //         prompt: "None",
  //         tools: ["Squish Preparation Tool"],
  //         model: {
  //           label: "GPT 4",
  //           field: "gpt4",
  //         },
  //         flow: {
  //           nodes: [
  //             {
  //               id: "0",
  //               type: "AgentNode",
  //               position: {
  //                 x: 300,
  //                 y: 150,
  //               },
  //               data: {
  //                 id: "0",
  //                 title: "Prepare for Squish Execution",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "generated_results_path",
  //                       type: TypeEnum.Input,
  //                       value: "$test_results",
  //                       description:
  //                         "Directory path containing generated test results to be used in Squish.",
  //                     },
  //                     {
  //                       key: "test_script_path",
  //                       type: TypeEnum.Input,
  //                       value:"$test_script.py",
  //                       description:
  //                         "Path to the test script file to be executed in Squish.",
  //                     },
  //                     {
  //                       key: "output_file_name",
  //                       type: TypeEnum.Input,
  //                       value:"$output_file.zip",
  //                       description:
  //                         "Name of the output file to be generated by Squish.",
  //                     },
  //                     {
  //                       key: "output_folder",
  //                       type: TypeEnum.Input,
  //                       value:"$output_folder",
  //                       description:
  //                         "Directory path where Squish output files will be saved.",
  //                     },
  //                   ],
  //                   output: {
  //                     type: "array",
  //                     description:
  //                       "Confirmation or paths of files prepared for Squish execution.",
  //                   },
  //                 },
  //               },
  //               className: "",
  //             },
  //           ],
  //           edges: [],
  //         },
  //         welcomeText:
  //           "Welcome to the Test Squish Bundle Agent. This agent will prepare your test cases and scripts for execution in the Squish framework.",
  //       },
  //       category: AgentCategoryEnum.Misc,
  //       logo: "/assets/images/randon-logo.png",
  //     },
  //   ],
  // },
  // {
  //   id: "2",
  //   logo: "/assets/images/randon-logo.png",
  //   name: "NTC Test Automation Team",
  //   description:
  //     "An automation workflow for generating test patterns, BDD test cases, scoring, storing in MongoDB, and preparing for Squish testing.",
  //   agents: [
  //     {
  //       id: "1",
  //       name: "Generate Test Pattern Agent",
  //       description:
  //         "An agent that generates structured test patterns from Excel data, parses it, and saves it for further testing processes.",
  //       agentFormData: {
  //         agentName: "Generate Test Pattern Agent",
  //         agentDescription:
  //           "This agent extracts data from an Excel file, parses it, and saves it in a structured format for creating test patterns.",
  //         prompt: "None",
  //         tools: [
  //           "Excel Tool",
  //           "Parsing Tool",
  //           "File Writing Tool - Test Case"
  //         ],
  //         model: {
  //           label: "GPT 4",
  //           field: "gpt4"
  //         },
  //         flow: {
  //           nodes: [
  //             {
  //               id: "0",
  //               type: "AgentNode",
  //               position: {
  //                 x: 300,
  //                 y: 150
  //               },
  //               data: {
  //                 id: "0",
  //                 title: "Extract Text from Excel",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "excel_path",
  //                       type: TypeEnum.Input,
  //                       description: "Path to the Excel file.",
  //                       value: "NT_Test_Scenarios_v1.0.xlsx",
  //                       defaultValue: "NT_Test_Scenarios_v1.0.xlsx"
  //                     }
  //                   ],
  //                   output: {
  //                     type: TypeEnum.Input,
  //                     description: "Extracted sheet data",
  //                     value: "$sheet_data"
  //                   }
  //                 }
  //               },
  //               className: ""
  //             },
  //             {
  //               id: "1",
  //               type: "AgentNode",
  //               position: {
  //                 x: 600,
  //                 y: 150
  //               },
  //               data: {
  //                 id: "1",
  //                 title: "Parse Excel Text",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "sheet_data",
  //                       type: TypeEnum.Input,
  //                       value: "$sheet_data",
  //                       description: "Data extracted from the Excel file."
  //                     }
  //                   ],
  //                   output: {
  //                     type: TypeEnum.Input,
  //                     value: "$test_cases",
  //                     description: "Parsed test pattern data"
  //                   }
  //                 }
  //               },
  //               className: ""
  //             },
  //             {
  //               id: "2",
  //               type: "AgentNode",
  //               position: {
  //                 x: 900,
  //                 y: 150
  //               },
  //               data: {
  //                 id: "2",
  //                 title: "Save Test Pattern",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "parsed_test_pattern",
  //                       type: TypeEnum.Input,
  //                       value: "$test_cases",
  //                       description: "Parsed test pattern data."
  //                     },
  //                     {
  //                       key: "output_path",
  //                       value: "$testcaseId.json",
  //                       type: TypeEnum.Input,
  //                       description: "Path to save the test pattern data."
  //                     }
  //                   ],
  //                   output: {
  //                     value:true,
  //                     type: TypeEnum.Switch,
  //                     description: "Confirmation of file creation"
  //                   }
  //                 }
  //               },
  //               className: ""
  //             }
  //           ],
  //           edges: [
  //             {
  //               id: "e0-1",
  //               source: "0",
  //               target: "1",
  //               type: "smoothstep"
  //             },
  //             {
  //               id: "e1-2",
  //               source: "1",
  //               target: "2",
  //               type: "smoothstep"
  //             }
  //           ]
  //         },
  //         welcomeText:
  //           "Welcome to the Generate Test Pattern Agent. This agent extracts, parses, and saves test patterns for further use."
  //       },
  //       category: AgentCategoryEnum.Generation,
  //       logo: "/assets/images/randon-logo.png"
  //     },
  //     {
  //       id: "2",
  //       name: "BDD Test Generation Agent",
  //       description:
  //         "An agent for generating BDD (Behavior-Driven Development) test files using structured test cases and predefined patterns.",
  //       agentFormData: {
  //         agentName: "BDD Test Generation Agent",
  //         agentDescription:
  //           "This agent generates feature files in BDD format from structured test cases, utilizing patterns for consistent and standardized test scenarios.",
  //         prompt: "None",
  //         tools: ["Feature Generation Tool"],
  //         model: {
  //           label: "GPT 4",
  //           field: "gpt4"
  //         },
  //         flow: {
  //           nodes: [
  //             {
  //               id: "0",
  //               type: "AgentNode",
  //               position: {
  //                 x: 300,
  //                 y: 150
  //               },
  //               data: {
  //                 id: "0",
  //                 title: "Generate Feature File",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "structured_test_cases",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Structured test cases to be used for feature file generation."
  //                     },
  //                     {
  //                       key: "pattern",
  //                       type: TypeEnum.Input,
  //                       value: "Common_Patterns_v1.4.md",
  //                       description:
  //                         "Path to the pattern file for BDD feature file creation."
  //                     },
  //                     {
  //                       key: "json_directory",
  //                       value:"$json_files",
  //                       type:TypeEnum.Input,
  //                       description:
  //                         "Directory for storing any generated JSON files."
  //                     },
  //                     {
  //                       key: "feature_file_output_path",
  //                       value:"$feature_file.feature",
  //                       type: TypeEnum.Input,
  //                       description: "Path to save the generated feature file."
  //                     }
  //                   ],
  //                   output: {
  //                     value:"$feature_file_output_path",
  //                     type: TypeEnum.Input,
  //                     description:
  //                       "Path to the generated BDD feature file or confirmation message."
  //                   }
  //                 }
  //               },
  //               className: ""
  //             }
  //           ],
  //           edges: []
  //         },
  //         welcomeText:
  //           "Welcome to the BDD Test Generation Agent. This agent will generate BDD feature files based on structured test cases and patterns."
  //       },
  //       category: AgentCategoryEnum.Generation,
  //       logo: "/assets/images/randon-logo.png"
  //     },
  //     {
  //       id: "3",
  //       name: "BDD Test Scoring Agent",
  //       description:
  //         "An agent for evaluating and scoring BDD (Behavior-Driven Development) feature files based on defined quality criteria and patterns.",
  //       agentFormData: {
  //         agentName: "BDD Test Scoring Agent",
  //         agentDescription:
  //           "This agent assesses the quality of BDD feature files by comparing them to established patterns, generating a quality score to ensure test scenarios meet specified standards.",
  //         prompt: "None",
  //         tools: ["Feature Evaluation Tool"],
  //         model: {
  //           label: "GPT 4",
  //           field: "gpt4"
  //         },
  //         flow: {
  //           nodes: [
  //             {
  //               id: "0",
  //               type: "AgentNode",
  //               position: {
  //                 x: 300,
  //                 y: 150
  //               },
  //               data: {
  //                 id: "0",
  //                 title: "Evaluate Feature File",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "structured_test_cases",
  //                       value:"$structured_test_cases",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Structured test cases used for evaluating the feature file."
  //                     },
  //                     {
  //                       key: "feature_file_result",
  //                       value: "$feature_file.feature",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Path to the generated BDD feature file to be evaluated."
  //                     },
  //                     {
  //                       key: "pattern",
  //                       value:"Common_Patterns_v1.4.md",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Path to the pattern file used as a reference for evaluation."
  //                     },
  //                     {
  //                       key: "evaluation_output_path",
  //                       value:"$evaluation_output.txt",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Path to save the evaluation results or quality score."
  //                     }
  //                   ],
  //                   output: {
  //                     type: "number",
  //                     value:"$evaluation_output.txt",
  //                     description:
  //                       "Quality score or evaluation result for the BDD feature file."
  //                   }
  //                 }
  //               },
  //               className: ""
  //             }
  //           ],
  //           edges: []
  //         },
  //         welcomeText:
  //           "Welcome to the BDD Test Scoring Agent. This agent evaluates the quality of BDD feature files, assigning a score based on predefined patterns and standards."
  //       },
  //       category: AgentCategoryEnum.Validation,
  //       logo: "/assets/images/randon-logo.png"
  //     },
  //     {
  //       id: "4",
  //       name: "Database Agent",
  //       description:
  //         "An agent for inserting and updating structured test case data in MongoDB, facilitating organized storage and easy retrieval of test data.",
  //       agentFormData: {
  //         agentName: "Database Agent",
  //         agentDescription:
  //           "This agent handles the insertion of test case data into a MongoDB collection, ensuring that test cases are stored in a structured and queryable format for future analysis.",
  //         prompt: "None",
  //         tools: ["MongoDB Tool"],
  //         model: {
  //           label: "GPT 4",
  //           field: "gpt4"
  //         },
  //         flow: {
  //           nodes: [
  //             {
  //               id: "0",
  //               type: "AgentNode",
  //               position: {
  //                 x: 300,
  //                 y: 150
  //               },
  //               data: {
  //                 id: "0",
  //                 title: "Update to MongoDB",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "readme_file_path",
  //                       type: TypeEnum.Input,
  //                       value:"$readme_output_path",
  //                       description:
  //                         "Path to the README file containing test case summaries."
  //                     },
  //                     {
  //                       key: "db_name",
  //                       value:"product",
  //                       type: TypeEnum.Input,
  //                       description: "Name of the MongoDB database."
  //                     },
  //                     {
  //                       key: "collection_name",
  //                       value:"test_cases",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Name of the MongoDB collection for storing test cases."
  //                     },
  //                     {
  //                       key: "connection_string",
  //                       value:"$connection_string",
  //                       type: TypeEnum.Input,
  //                       description: "Connection string for MongoDB instance."
  //                     },
  //                     {
  //                       key: "base_path",
  //                       type: TypeEnum.Input,
  //                       value:"$sharepoint_url",
  //                       description:
  //                         "Base URL for linked resources associated with the test cases."
  //                     }
  //                   ],
  //                   output: {
  //                     type: TypeEnum.Switch,
  //                     value:true,
  //                     description:
  //                       "Confirmation of successful MongoDB insertion."
  //                   }
  //                 }
  //               },
  //               className: ""
  //             }
  //           ],
  //           edges: []
  //         },
  //         welcomeText:
  //           "Welcome to the MongoDB Agent. This agent will insert structured test case data into MongoDB for organized storage and retrieval."
  //       },
  //       category: AgentCategoryEnum.Database,
  //       logo: "/assets/images/randon-logo.png"
  //     },
  //     {
  //       id: "5",
  //       name: "Test Squish Bundle Agent",
  //       description:
  //         "An agent for preparing test cases and related files for execution with the Squish testing framework.",
  //       agentFormData: {
  //         agentName: "Test Squish Bundle Agent",
  //         agentDescription:
  //           "This agent organizes and prepares test case files and scripts for execution in the Squish automated testing framework, ensuring that all necessary files are in place for a smooth test run.",
  //         prompt: "None",
  //         tools: ["Squish Preparation Tool"],
  //         model: {
  //           label: "GPT 4",
  //           field: "gpt4"
  //         },
  //         flow: {
  //           nodes: [
  //             {
  //               id: "0",
  //               type: "AgentNode",
  //               position: {
  //                 x: 300,
  //                 y: 150
  //               },
  //               data: {
  //                 id: "0",
  //                 title: "Prepare for Squish Execution",
  //                 formData: {
  //                   input: [
  //                     {
  //                       key: "generated_results_path",
  //                       type: TypeEnum.Input,
  //                       value: "$test_results",
  //                       description:
  //                         "Directory path containing generated test results to be used in Squish."
  //                     },
  //                     {
  //                       key: "test_script_path",
  //                       value:"$test_script.py",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Path to the test script file to be executed in Squish."
  //                     },
  //                     {
  //                       key: "output_file_name",
  //                       value:"$output_file.zip",
  //                       type: TypeEnum.Input,
  //                       description:
  //                         "Name of the output file to be generated by Squish."
  //                     },
  //                     {
  //                       key: "output_folder",
  //                       type: TypeEnum.Input,
  //                       value:"$output_folder",
  //                       description:
  //                         "Directory path where Squish output files will be saved."
  //                     }
  //                   ],
  //                   output: {
  //                     type: "array",
  //                     description:
  //                       "Confirmation or paths of files prepared for Squish execution."
  //                   }
  //                 }
  //               },
  //               className: ""
  //             }
  //           ],
  //           edges: []
  //         },
  //         welcomeText:
  //           "Welcome to the Test Squish Bundle Agent. This agent will prepare your test cases and scripts for execution in the Squish framework."
  //       },
  //       category: AgentCategoryEnum.Misc,
  //       logo: "/assets/images/randon-logo.png"
  //     }
  //   ]
  // },
  {
    id: "3",
    logo: "/assets/images/randon-logo.png",
    name: "EJB to gRPC Conversion Team",
    description: "An automation workflow for converting EJB services to gRPC, including bean analysis, .proto generation, service implementation, server-client setup, review, and scoring.",
    "agents": [
      {
        "id": "0",
        "name": "Inputs",
        "description": "Analyzes an EJB bean to extract details such as class name, properties, constructors, and methods.",
        "agentFormData": {
          "agentName": "Bean Analysis Agent",
          "agentDescription": "This agent extracts and analyzes the structure of EJB beans, producing detailed markdown outputs for understanding the class and its components.",
          "prompt": "None",
          "tools": ["Bean Analysis Tool"],
          "model": {
            "label": "GPT 4",
            "field": "gpt4"
          },
          "flow": {
            "nodes": [
              {
                "id": "0",
                "type": "AgentNode",
                "position": {
                  "x": 300,
                  "y": 150
                },
                "data": {
                  "id": "0",
                  "title": "Analyze Bean",
                  "formData": {
                    "input": [
                      {
                        "key": "bean_file_path",
                        "type": TypeEnum.Input,
                        "description": "Path to the EJB bean file.",
                        "value": "$bean_input",
                        "defaultValue": "example_bean.java"
                      }
                    ],
                    "output": {
                      "type": TypeEnum.Input,
                      "description": "Extracted bean analysis data.",
                      "value": "$bean_analysis"
                    }
                  }
                },
                "className": ""
              }
            ],
            "edges": []
          },
          "welcomeText": "Welcome to the Bean Analysis Agent. Provide an EJB bean file to extract and analyze its structure."
        },
        "category": AgentCategoryEnum.Analyser,
        "logo": "/assets/images/randon-logo.png"
      },
      {
        "id": "1",
        "name": "Bean Analysis Agent",
        "description": "Analyzes an EJB bean to extract details such as class name, properties, constructors, and methods.",
        "agentFormData": {
          "agentName": "Bean Analysis Agent",
          "agentDescription": "This agent extracts and analyzes the structure of EJB beans, producing detailed markdown outputs for understanding the class and its components.",
          "prompt": "None",
          "tools": ["Bean Analysis Tool"],
          "model": {
            "label": "GPT 4",
            "field": "gpt4"
          },
          "flow": {
            "nodes": [
              {
                "id": "0",
                "type": "AgentNode",
                "position": {
                  "x": 300,
                  "y": 150
                },
                "data": {
                  "id": "0",
                  "title": "Analyze Bean",
                  "formData": {
                    "input": [
                      {
                        "key": "bean_file_path",
                        "type": TypeEnum.Input,
                        "description": "Path to the EJB bean file.",
                        "value": "$bean_input",
                        "defaultValue": "example_bean.java"
                      }
                    ],
                    "output": {
                      "type": TypeEnum.Input,
                      "description": "Extracted bean analysis data.",
                      "value": "$bean_analysis"
                    }
                  }
                },
                "className": ""
              }
            ],
            "edges": []
          },
          "welcomeText": "Welcome to the Bean Analysis Agent. Provide an EJB bean file to extract and analyze its structure."
        },
        "category": AgentCategoryEnum.Analyser,
        "logo": "/assets/images/randon-logo.png"
      },
      {
        "id": "2",
        "name": "Proto File Generation Agent",
        "description": "Generates a .proto file for gRPC services from EJB beans and model definitions.",
        "agentFormData": {
          "agentName": "Proto File Generation Agent",
          "agentDescription": "This agent uses EJB beans and model definitions to generate a .proto file, defining gRPC services and messages.",
          "prompt": "None",
          "tools": ["Proto File Generator"],
          "model": {
            "label": "GPT 4",
            "field": "gpt4"
          },
          "flow": {
            "nodes": [
              {
                "id": "0",
                "type": "AgentNode",
                "position": {
                  "x": 300,
                  "y": 150
                },
                "data": {
                  "id": "0",
                  "title": "Generate .proto File",
                  "formData": {
                    "input": [
                      {
                        "key": "bean_analysis",
                        "type": TypeEnum.Input,
                        "description": "Analyzed EJB bean data.",
                        "value": "$bean_analysis"
                      },
                      {
                        "key": "model_definitions",
                        "type": TypeEnum.Input,
                        "description": "Paths to model definition files.",
                        "value": "$model_files"
                      }
                    ],
                    "output": {
                      "type": TypeEnum.Input,
                      "description": "Generated .proto file.",
                      "value": "$proto_file"
                    }
                  }
                },
                "className": ""
              }
            ],
            "edges": []
          },
          "welcomeText": "Welcome to the Proto File Generation Agent. Provide analyzed EJB bean data and model definitions to generate a .proto file."
        },
        "category": AgentCategoryEnum.Generation,
        "logo": "/assets/images/randon-logo.png"
      },
      {
        "id": "3",
        "name": "gRPC Service Implementation Agent",
        "description": "Generates the Java implementation for gRPC services based on a .proto file and EJB bean methods.",
        "agentFormData": {
          "agentName": "gRPC Service Implementation Agent",
          "agentDescription": "This agent generates a gRPC service implementation by translating EJB service methods into gRPC methods, preserving existing functionality.",
          "prompt": "None",
          "tools": ["gRPC Service Generator"],
          "model": {
            "label": "GPT 4",
            "field": "gpt4"
          },
          "flow": {
            "nodes": [
              {
                "id": "0",
                "type": "AgentNode",
                "position": {
                  "x": 300,
                  "y": 150
                },
                "data": {
                  "id": "0",
                  "title": "Generate gRPC Service",
                  "formData": {
                    "input": [
                      {
                        "key": "proto_file",
                        "type": TypeEnum.Input,
                        "description": "Generated .proto file.",
                        "value": "$proto_file"
                      },
                      {
                        "key": "bean_methods",
                        "type": TypeEnum.Input,
                        "description": "Methods from the EJB bean.",
                        "value": "$bean_methods"
                      }
                    ],
                    "output": {
                      "type": TypeEnum.Input,
                      "description": "Java implementation of the gRPC service.",
                      "value": "$grpc_service"
                    }
                  }
                },
                "className": ""
              }
            ],
            "edges": []
          },
          "welcomeText": "Welcome to the gRPC Service Implementation Agent. Provide the .proto file and bean methods to generate the service implementation."
        },
        "category": AgentCategoryEnum.Generation,
        "logo": "/assets/images/randon-logo.png"
      },
      {
        "id": "4",
        "name": "Server and Client Setup Agent",
        "description": "Prepares the server and client implementations for gRPC communication based on the .proto file and service implementation.",
        "agentFormData": {
          "agentName": "Server and Client Setup Agent",
          "agentDescription": "This agent generates gRPC server and client implementations to enable seamless communication based on the service definitions.",
          "prompt": "None",
          "tools": ["gRPC ServerClient Generator"],
          "model": {
            "label": "GPT 4",
            "field": "gpt4"
          },
          "flow": {
            "nodes": [
              {
                "id": "0",
                "type": "AgentNode",
                "position": {
                  "x": 300,
                  "y": 150
                },
                "data": {
                  "id": "0",
                  "title": "Generate Server and Client",
                  "formData": {
                    "input": [
                      {
                        "key": "proto_file",
                        "type": TypeEnum.Input,
                        "description": "Generated .proto file.",
                        "value": "$proto_file"
                      },
                      {
                        "key": "grpc_service",
                        "type": TypeEnum.Input,
                        "description": "gRPC service implementation.",
                        "value": "$grpc_service"
                      }
                    ],
                    "output": {
                      "type": TypeEnum.Input,
                      "description": "Generated server and client implementations.",
                      "value": "$server_client"
                    }
                  }
                },
                "className": ""
              }
            ],
            "edges": []
          },
          "welcomeText": "Welcome to the Server and Client Setup Agent. Provide the .proto file and service implementation to generate server and client code."
        },
        "category": AgentCategoryEnum.Generation,
        "logo": "/assets/images/randon-logo.png"
      },
      {
        "id": "5",
        "name": "Code Review Agent",
        "description": "Reviews the generated gRPC code, including proto files, service implementations, and server-client setup.",
        "agentFormData": {
          "agentName": "Code Review Agent",
          "agentDescription": "This agent evaluates the generated code for correctness, efficiency, and adherence to best practices.",
          "prompt": "None",
          "tools": ["Review Generated Code"],
          "model": {
            "label": "GPT 4",
            "field": "gpt4"
          },
          "flow": {
            "nodes": [
              {
                "id": "0",
                "type": "AgentNode",
                "position": {
                  "x": 300,
                  "y": 150
                },
                "data": {
                  "id": "0",
                  "title": "Review Generated Code",
                  "formData": {
                    "input": [
                      {
                        "key": "grpc_code",
                        "type": TypeEnum.Input,
                        "description": "Path to the generated gRPC code for review.",
                        "value": "$generated_code"
                      },
                      {
                        "key": "review_output_path",
                        "type": TypeEnum.Input,
                        "description": "Path to save the review results.",
                        "value": "$review_output"
                      }
                    ],
                    "output": {
                      "type": TypeEnum.Input,
                      "description": "Review report.",
                      "value": "$review_report"
                    }
                  }
                },
                "className": ""
              }
            ],
            "edges": []
          },
          "welcomeText": "Welcome to the Code Review Agent. Provide the generated gRPC code for evaluation and review."
        },
        "category": AgentCategoryEnum.Validation,
        "logo": "/assets/images/randon-logo.png"
      },
      {
        "id": "6",
        "name": "Code Scoring Agent",
        "description": "Scores the quality of the generated gRPC code based on predefined criteria and standards.",
        "agentFormData": {
          "agentName": "Code Scoring Agent",
          "agentDescription": "This agent assigns a quality score to the generated gRPC code, ensuring adherence to standards and best practices.",
          "prompt": "None",
          "tools": ["Score Generated Code"],
          "model": {
            "label": "GPT 4",
            "field": "gpt4"
          },
          "flow": {
            "nodes": [
              {
                "id": "0",
                "type": "AgentNode",
                "position": {
                  "x": 300,
                  "y": 150
                },
                "data": {
                  "id": "0",
                  "title": "Score Generated Code",
                  "formData": {
                    "input": [
                      {
                        "key": "grpc_code",
                        "type": TypeEnum.Input,
                        "description": "Path to the generated gRPC code for scoring.",
                        "value": "$generated_code"
                      },
                      {
                        "key": "scoring_output_path",
                        "type": TypeEnum.Input,
                        "description": "Path to save the scoring results.",
                        "value": "$scoring_output"
                      }
                    ],
                    "output": {
                      "type": TypeEnum.Input,
                      "description": "Scoring report.",
                      "value": "$scoring_report"
                    }
                  }
                },
                "className": ""
              }
            ],
            "edges": []
          },
          "welcomeText": "Welcome to the Code Scoring Agent. Provide the generated gRPC code for scoring."
        },
        "category": AgentCategoryEnum.Validation,
        "logo": "/assets/images/randon-logo.png"
      }
    ]
  },
  {
    "id": "4",
    "logo": "/assets/images/randon-logo.png",
    "name": "Oracle to MongoDB Conversion Team",
    "description": "An automation workflow for converting Oracle-based data and applications to MongoDB, including data access layer analysis, schema creation, DAL refactoring, review, and scoring.",
    "agents": [
      {
        "id": "0",
        "name": "Inputs",
        "description": "Analyzes an EJB bean to extract details such as class name, properties, constructors, and methods.",
        "agentFormData": {
          "agentName": "Bean Analysis Agent",
          "agentDescription": "This agent extracts and analyzes the structure of EJB beans, producing detailed markdown outputs for understanding the class and its components.",
          "prompt": "None",
          "tools": ["Bean Analysis Tool"],
          "model": {
            "label": "GPT 4",
            "field": "gpt4"
          },
          "flow": {
            "nodes": [
              {
                "id": "0",
                "type": "AgentNode",
                "position": {
                  "x": 300,
                  "y": 150
                },
                "data": {
                  "id": "0",
                  "title": "Analyze Bean",
                  "formData": {
                    "input": [
                      {
                        "key": "bean_file_path",
                        "type": TypeEnum.Input,
                        "description": "Path to the EJB bean file.",
                        "value": "$bean_input",
                        "defaultValue": "example_bean.java"
                      }
                    ],
                    "output": {
                      "type": TypeEnum.Input,
                      "description": "Extracted bean analysis data.",
                      "value": "$bean_analysis"
                    }
                  }
                },
                "className": ""
              }
            ],
            "edges": []
          },
          "welcomeText": "Welcome to the Bean Analysis Agent. Provide an EJB bean file to extract and analyze its structure."
        },
        "category": AgentCategoryEnum.Analyser,
        "logo": "/assets/images/randon-logo.png"
      },
      {
        "id": "1",
        "name": "Data Access Layer Analysis Agent",
        "description": "Analyzes Oracle data access layer (DAL) code to extract methods, stored procedures, and functions for conversion planning.",
        "agentFormData": {
          "agentName": "Data Access Layer Analysis Agent",
          "agentDescription": "This agent analyzes the Oracle DAL code to extract method details, stored procedures, and functions for schema and DAL conversion.",
          "prompt": "None",
          "tools": ["DAL Analysis Tool"],
          "model": {
            "label": "GPT 4",
            "field": "gpt4"
          },
          "flow": {
            "nodes": [
              {
                "id": "0",
                "type": "AgentNode",
                "position": {
                  "x": 300,
                  "y": 150
                },
                "data": {
                  "id": "0",
                  "title": "Analyze Data Access Layer Code",
                  "formData": {
                    "input": [
                      {
                        "key": "dal_code_path",
                        "type": TypeEnum.Input,
                        "description": "Path to the Oracle DAL code file.",
                        "value": "$oracle_dal_code",
                        "defaultValue": "example_dal_code.java"
                      }
                    ],
                    "output": {
                      "type": TypeEnum.Input,
                      "description": "Extracted DAL analysis data.",
                      "value": "$dal_analysis"
                    }
                  }
                },
                "className": ""
              }
            ],
            "edges": []
          },
          "welcomeText": "Welcome to the Data Access Layer Analysis Agent. Provide Oracle DAL code to extract and analyze methods and procedures."
        },
        "category": AgentCategoryEnum.Analyser,
        "logo": "/assets/images/randon-logo.png"
      },
      {
        "id": "2",
        "name": "Oracle Schema Analysis Agent",
        "description": "Analyzes Oracle schemas, stored procedures, and functions to extract structure and relationships.",
        "agentFormData": {
          "agentName": "Oracle Schema Analysis Agent",
          "agentDescription": "This agent extracts and analyzes Oracle schema details, including table structures, stored procedures, and functions, for schema conversion planning.",
          "prompt": "None",
          "tools": ["Oracle Schema Analysis Tool"],
          "model": {
            "label": "GPT 4",
            "field": "gpt4"
          },
          "flow": {
            "nodes": [
              {
                "id": "0",
                "type": "AgentNode",
                "position": {
                  "x": 300,
                  "y": 150
                },
                "data": {
                  "id": "0",
                  "title": "Analyze Oracle Schema",
                  "formData": {
                    "input": [
                      {
                        "key": "oracle_schema_path",
                        "type": TypeEnum.Input,
                        "description": "Path to the Oracle schema or package file.",
                        "value": "$oracle_schema",
                        "defaultValue": "example_oracle_package.sql"
                      }
                    ],
                    "output": {
                      "type": TypeEnum.Input,
                      "description": "Extracted schema analysis data.",
                      "value": "$schema_analysis"
                    }
                  }
                },
                "className": ""
              }
            ],
            "edges": []
          },
          "welcomeText": "Welcome to the Oracle Schema Analysis Agent. Provide Oracle schema details for extraction and analysis."
        },
        "category": AgentCategoryEnum.Analyser,
        "logo": "/assets/images/randon-logo.png"
      },
      {
        "id": "3",
        "name": "MongoDB Schema Creation Agent",
        "description": "Creates a MongoDB schema based on Oracle schema analysis, leveraging embedding and collections for efficient queries.",
        "agentFormData": {
          "agentName": "MongoDB Schema Creation Agent",
          "agentDescription": "This agent generates MongoDB schemas using Oracle schema analysis, optimizing for embedding and document structure.",
          "prompt": "None",
          "tools": ["MongoDB Schema Creator"],
          "model": {
            "label": "GPT 4",
            "field": "gpt4"
          },
          "flow": {
            "nodes": [
              {
                "id": "0",
                "type": "AgentNode",
                "position": {
                  "x": 300,
                  "y": 150
                },
                "data": {
                  "id": "0",
                  "title": "Create MongoDB Schema",
                  "formData": {
                    "input": [
                      {
                        "key": "schema_analysis",
                        "type": TypeEnum.Input,
                        "description": "Analyzed Oracle schema data.",
                        "value": "$schema_analysis"
                      }
                    ],
                    "output": {
                      "type": TypeEnum.Input,
                      "description": "Generated MongoDB schema.",
                      "value": "$mongodb_schema"
                    }
                  }
                },
                "className": ""
              }
            ],
            "edges": []
          },
          "welcomeText": "Welcome to the MongoDB Schema Creation Agent. Use Oracle schema analysis to create a MongoDB schema."
        },
        "category": AgentCategoryEnum.Generation,
        "logo": "/assets/images/randon-logo.png"
      },
      {
        "id": "4",
        "name": "Data Access Layer Refactoring Agent",
        "description": "Refactors the data access layer (DAL) from Oracle to MongoDB, replacing JDBC with MongoDB repositories.",
        "agentFormData": {
          "agentName": "Data Access Layer Refactoring Agent",
          "agentDescription": "This agent refactors Oracle-based data access layers to use MongoDB, including repository and model creation.",
          "prompt": "None",
          "tools": ["DAL Refactoring Tool"],
          "model": {
            "label": "GPT 4",
            "field": "gpt4"
          },
          "flow": {
            "nodes": [
              {
                "id": "0",
                "type": "AgentNode",
                "position": {
                  "x": 300,
                  "y": 150
                },
                "data": {
                  "id": "0",
                  "title": "Refactor Data Access Layer",
                  "formData": {
                    "input": [
                      {
                        "key": "mongodb_schema",
                        "type": TypeEnum.Input,
                        "description": "Generated MongoDB schema.",
                        "value": "$mongodb_schema"
                      },
                      {
                        "key": "oracle_dal_code",
                        "type": TypeEnum.Input,
                        "description": "Path to Oracle DAL code for refactoring.",
                        "value": "$oracle_dal_code"
                      }
                    ],
                    "output": {
                      "type": TypeEnum.Input,
                      "description": "Refactored MongoDB DAL code.",
                      "value": "$mongodb_dal_code"
                    }
                  }
                },
                "className": ""
              }
            ],
            "edges": []
          },
          "welcomeText": "Welcome to the Data Access Layer Refactoring Agent. Provide Oracle DAL code to refactor for MongoDB."
        },
        "category": AgentCategoryEnum.Generation,
        "logo": "/assets/images/randon-logo.png"
      },
      {
        "id": "5",
        "name": "Code Review Agent",
        "description": "Reviews the refactored MongoDB DAL code for correctness, efficiency, and adherence to standards.",
        "agentFormData": {
          "agentName": "Code Review Agent",
          "agentDescription": "This agent evaluates the refactored MongoDB DAL code for quality and adherence to standards.",
          "prompt": "None",
          "tools": ["Review Generated Code"],
          "model": {
            "label": "GPT 4",
            "field": "gpt4"
          },
          "flow": {
            "nodes": [
              {
                "id": "0",
                "type": "AgentNode",
                "position": {
                  "x": 300,
                  "y": 150
                },
                "data": {
                  "id": "0",
                  "title": "Review Refactored Code",
                  "formData": {
                    "input": [
                      {
                        "key": "mongodb_dal_code",
                        "type": TypeEnum.Input,
                        "description": "Path to the refactored MongoDB DAL code.",
                        "value": "$mongodb_dal_code"
                      },
                      {
                        "key": "review_output_path",
                        "type": TypeEnum.Input,
                        "description": "Path to save the review report.",
                        "value": "$review_output"
                      }
                    ],
                    "output": {
                      "type": TypeEnum.Input,
                      "description": "Review report.",
                      "value": "$review_report"
                    }
                  }
                },
                "className": ""
              }
            ],
            "edges": []
          },
          "welcomeText": "Welcome to the Code Review Agent. Provide refactored MongoDB DAL code for review."
        },
        "category": AgentCategoryEnum.Validation,
        "logo": "/assets/images/randon-logo.png"
      },
      {
        "id": "6",
        "name": "Code Scoring Agent",
        "description": "Scores the refactored MongoDB DAL code for quality based on predefined criteria.",
        "agentFormData": {
          "agentName": "Code Scoring Agent",
          "agentDescription": "This agent scores the MongoDB DAL code, ensuring quality and alignment with best practices.",
          "prompt": "None",
          "tools": ["Score Generated Code"],
          "model": {
            "label": "GPT 4",
            "field": "gpt4"
          },
          "flow": {
            "nodes": [
              {
                "id": "0",
                "type": "AgentNode",
                "position": {
                  "x": 300,
                  "y": 150
                },
                "data": {
                  "id": "0",
                  "title": "Score Refactored Code",
                  "formData": {
                    "input": [
                      {
                        "key": "mongodb_dal_code",
                        "type": TypeEnum.Input,
                        "description": "Path to the refactored MongoDB DAL code for scoring.",
                        "value": "$mongodb_dal_code"
                      },
                      {
                        "key": "scoring_output_path",
                        "type": TypeEnum.Input,
                        "description": "Path to save the scoring report.",
                        "value": "$scoring_output"
                      }
                    ],
                    "output": {
                      "type": TypeEnum.Input,
                      "description": "Scoring report.",
                      "value": "$scoring_report"
                    }
                  }
                },
                "className": ""
              }
            ],
            "edges": []
          },
          "welcomeText": "Welcome to the Code Scoring Agent. Provide refactored MongoDB DAL code for scoring."
        },
        "category": AgentCategoryEnum.Validation,
        "logo": "/assets/images/randon-logo.png"
      }
    ]
  }  
];
